import { render, staticRenderFns } from "./PayBusinessReferral.vue?vue&type=template&id=6c7c05b8&"
import script from "./PayBusinessReferral.vue?vue&type=script&lang=js&"
export * from "./PayBusinessReferral.vue?vue&type=script&lang=js&"
import style0 from "./PayBusinessReferral.vue?vue&type=style&index=0&id=6c7c05b8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports